import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const ArchiveSpacePortal: LoadableType<{
	spaceKey: string;
	pathname: string;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ArchiveSpacePortal" */ '../src/ArchiveSpacePortal.tsx'
			)
		).ArchiveSpacePortal,
	name: 'ArchiveSpacePortal',
});
